import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38cf969c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
}
const _hoisted_2 = ["onClick"]

import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute, RouteRecordRaw, RouteLocationMatched } from 'vue-router'

interface BreadcrumbItem extends RouteLocationMatched {
  redirect?: string;
  path: string;
  meta: {
    title: string;
    breadcrumb?: boolean;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const levelList = ref<BreadcrumbItem[]>([])

watch(() => route.path, (path) => {
  // if you go to the redirect page, do not update the breadcrumbs
  if (path.startsWith('/redirect/')) {
    return
  }
  getBreadcrumb()
}, { immediate: true })

function getBreadcrumb() {
  // only show routes with meta.title
  let matched = route.matched.filter(item => item.meta && item.meta.title) as BreadcrumbItem[]
  const first = matched[0]

  if (!isDashboard(first)) {
    matched = [{ path: '/index', meta: { title: '首页' }} as BreadcrumbItem].concat(matched)
  }

  levelList.value = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
}

function isDashboard(route: BreadcrumbItem) {
  const name = route && route.name
  if (!name) {
    return false
  }
  return String(name).trim() === 'Index'
}

function handleLink(item: BreadcrumbItem) {
  const { redirect, path } = item
  if (redirect) {
    router.push(redirect)
    return
  }
  router.push(path)
}

onMounted(() => {
  getBreadcrumb()
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "app-breadcrumb",
    separator: "/"
  }, {
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, { name: "breadcrumb" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levelList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withCtx(() => [
                (item.redirect === 'noRedirect' || index == levelList.value.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _withModifiers(($event: any) => (handleLink(item)), ["prevent"])
                    }, _toDisplayString(item.meta.title), 9, _hoisted_2))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})